import React from "react";

import ManageContentProvidersView from "./ManageContentProvidersView";

const ManageContentProviders = () => {
  return <ManageContentProvidersView />;
};

export default ManageContentProviders;
